<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import Sidebar from '@/components/Course_Antagonist/Sidebar';
import Info from '@/components/Course_Antagonist/Info';
import Lecture from '@/components/Course_Antagonist/Lecture';
import Video from '@/components/Course_Antagonist/Video';
import Finish from '@/components/Course_Antagonist/Finish';
import Exam from '@/components/Course_Antagonist/Exam';

export default {
  name: 'Home',
  components: {
    Sidebar,
    Info,
    Lecture,
    Video,
    Finish,
    Exam,
  },
  computed: {
    ...mapState('antagonist', {
      course: state => state.course,
      current: state => state.current,
    }),
    ...mapGetters('antagonist', [
      'isLoggedIn',
      'courseComponent',
    ]),
  },
  methods: {
    ...mapActions('antagonist', [
      'fetchUser',
    ]),
    ...mapMutations('antagonist', [
      'reset',
    ]),
  },
  created() {
    this.fetchUser();
  },
};
</script>
<template>
    <div id="course" class="container pt-5">
        <div class="row" v-if="current !== 'exam'">
            <div class="col-lg-4">
                <Sidebar />
            </div>
            <div class="col-lg-8">
                <Component :is="courseComponent" />
            </div>
        </div>
        <Exam v-else />
    </div>
</template>
